import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { updateCart } from '../../actions/cartActions';
import addBtn from '../../images/plus.png';
import { connect } from 'react-redux';
import { removeFromCart } from '../../actions/cartActions';

class ProductPreview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rotation: 0,
            addedToCart: false
        }
        this.rotate = this.rotate.bind(this);
    }

    rotate() {
        let newRotation = this.state.rotation + 45;
        if (newRotation >= 360) {
            newRotation = - 360;
        }
        this.setState({
            rotation: newRotation,
        })
    }

    updateCart = () => {
        this.props.updateCart(this.props.product, true)
    }

    onAddProduct = () => {
        this.rotate()
        this.updateCart()
    }

    deleteFromCart = () => {
        this.props.removeFromCart(this.props.product);
    };

    onBtnClick = () => {
        if (!this.state.addedToCart) {
            this.onAddProduct()
        } else {
            this.deleteFromCart()
        }
        this.setState({
            addedToCart: !this.state.addedToCart,
        })
    }
    render() {
        const thisProduct = this.props.product
        const { rotation } = this.state;

        return (
            <div className="ProductPreview" key={thisProduct._id}>
                <Link to={'/products/' + thisProduct._id}>

                    <div className="image-wrapper">
                        <img src={thisProduct.image.link} alt="" />
                    </div>
                </Link>
                <div className="prev-details-section">
                    <div>
                        <h3> {thisProduct.productDisplayName}</h3>
                        <h4>&#36;{thisProduct.price}</h4>
                    </div>

                    <div className="image-btn">
                        <img onClick={this.onBtnClick}
                            style={{ transform: `rotate(${rotation}deg)` }}
                            className='rotate'
                            src={addBtn}
                            alt="" />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        cart: state.cart.cart
    }
}

const mapDispatchToProps = {
    updateCart,
    removeFromCart
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductPreview)

